@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_693_906_901)
public val Res.string.answers_group_no_answer: StringResource by lazy {
      StringResource("string:answers_group_no_answer", "answers_group_no_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22302, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30894, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17829, 55),
      ))
    }

@delegate:ResourceContentHash(-392_253_472)
public val Res.string.answers_group_unavailable: StringResource by lazy {
      StringResource("string:answers_group_unavailable", "answers_group_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22366, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30970, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17885, 57),
      ))
    }

@delegate:ResourceContentHash(1_007_948_636)
public val Res.string.answers_hide_people: StringResource by lazy {
      StringResource("string:answers_hide_people", "answers_hide_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22428, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31040, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17943, 43),
      ))
    }

@delegate:ResourceContentHash(-1_759_973_274)
public val Res.string.answers_no_answer: StringResource by lazy {
      StringResource("string:answers_no_answer", "answers_no_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22472, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31104, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17987, 45),
      ))
    }

@delegate:ResourceContentHash(547_967_182)
public val Res.string.answers_show_people: StringResource by lazy {
      StringResource("string:answers_show_people", "answers_show_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22526, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31174, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18033, 43),
      ))
    }

@delegate:ResourceContentHash(1_582_239_054)
public val Res.string.answers_slot_only_other: StringResource by lazy {
      StringResource("string:answers_slot_only_other", "answers_slot_only_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22570, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31238, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18077, 51),
      ))
    }

@delegate:ResourceContentHash(318_096_112)
public val Res.string.answers_title: StringResource by lazy {
      StringResource("string:answers_title", "answers_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22630, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31310, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18129, 45),
      ))
    }

@delegate:ResourceContentHash(190_519_112)
public val Res.string.answers_whole_day: StringResource by lazy {
      StringResource("string:answers_whole_day", "answers_whole_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22688, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31384, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18175, 45),
      ))
    }

@delegate:ResourceContentHash(-860_716_507)
public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22730, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31438, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18221, 28),
      ))
    }

@delegate:ResourceContentHash(-1_863_560_400)
public val Res.string.appearance_accent: StringResource by lazy {
      StringResource("string:appearance_accent", "appearance_accent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22880, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31612, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18371, 33),
      ))
    }

@delegate:ResourceContentHash(-297_885_217)
public val Res.string.appearance_accent_bronze: StringResource by lazy {
      StringResource("string:appearance_accent_bronze", "appearance_accent_bronze", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22759, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31467, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18250, 40),
      ))
    }

@delegate:ResourceContentHash(2_124_196_027)
public val Res.string.appearance_accent_gold: StringResource by lazy {
      StringResource("string:appearance_accent_gold", "appearance_accent_gold", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22800, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31516, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18291, 38),
      ))
    }

@delegate:ResourceContentHash(-1_231_287_324)
public val Res.string.appearance_accent_silver: StringResource by lazy {
      StringResource("string:appearance_accent_silver", "appearance_accent_silver", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22839, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31563, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18330, 40),
      ))
    }

@delegate:ResourceContentHash(750_434_664)
public val Res.string.appearance_apply: StringResource by lazy {
      StringResource("string:appearance_apply", "appearance_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22930, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31674, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18405, 32),
      ))
    }

@delegate:ResourceContentHash(22_146_264)
public val Res.string.appearance_base: StringResource by lazy {
      StringResource("string:appearance_base", "appearance_base", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23106, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31926, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18573, 39),
      ))
    }

@delegate:ResourceContentHash(-525_639_528)
public val Res.string.appearance_base_bottle_green: StringResource by lazy {
      StringResource("string:appearance_base_bottle_green", "appearance_base_bottle_green", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22967, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31731, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18438, 52),
      ))
    }

@delegate:ResourceContentHash(726_567_007)
public val Res.string.appearance_base_burgundy: StringResource by lazy {
      StringResource("string:appearance_base_burgundy", "appearance_base_burgundy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23028, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31812, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18491, 44),
      ))
    }

@delegate:ResourceContentHash(-1_284_610_799)
public val Res.string.appearance_base_navy: StringResource by lazy {
      StringResource("string:appearance_base_navy", "appearance_base_navy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23069, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31869, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18536, 36),
      ))
    }

@delegate:ResourceContentHash(-1_924_971_401)
public val Res.string.appearance_current: StringResource by lazy {
      StringResource("string:appearance_current", "appearance_current", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23150, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 31986, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18613, 46),
      ))
    }

@delegate:ResourceContentHash(1_689_877_824)
public val Res.string.appearance_hint: StringResource by lazy {
      StringResource("string:appearance_hint", "appearance_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23193, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32029, 271),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18660, 179),
      ))
    }

@delegate:ResourceContentHash(-289_882_300)
public val Res.string.appearance_preview: StringResource by lazy {
      StringResource("string:appearance_preview", "appearance_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23373, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32301, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18840, 38),
      ))
    }

@delegate:ResourceContentHash(1_289_216_535)
public val Res.string.appearance_title: StringResource by lazy {
      StringResource("string:appearance_title", "appearance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23412, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32380, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18879, 40),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.applicant_availability: StringResource by lazy {
      StringResource("string:applicant_availability", "applicant_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23449, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32421, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18920, 46),
      ))
    }

@delegate:ResourceContentHash(480_801_048)
public val Res.string.applicant_call: StringResource by lazy {
      StringResource("string:applicant_call", "applicant_call", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23504, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32484, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18967, 30),
      ))
    }

@delegate:ResourceContentHash(-858_220_466)
public val Res.string.applicant_consent_future: StringResource by lazy {
      StringResource("string:applicant_consent_future", "applicant_consent_future", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23539, 124),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32535, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18998, 100),
      ))
    }

@delegate:ResourceContentHash(1_659_639_825)
public val Res.string.applicant_cv: StringResource by lazy {
      StringResource("string:applicant_cv", "applicant_cv", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23664, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32700, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19099, 44),
      ))
    }

@delegate:ResourceContentHash(-650_494_233)
public val Res.string.applicant_delete: StringResource by lazy {
      StringResource("string:applicant_delete", "applicant_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23972, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33148, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19379, 52),
      ))
    }

@delegate:ResourceContentHash(-2_046_769_139)
public val Res.string.applicant_delete_confirm_text: StringResource by lazy {
      StringResource("string:applicant_delete_confirm_text", "applicant_delete_confirm_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23709, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32769, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19144, 113),
      ))
    }

@delegate:ResourceContentHash(-2_125_085_552)
public val Res.string.applicant_delete_confirm_title: StringResource by lazy {
      StringResource("string:applicant_delete_confirm_title", "applicant_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23847, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 32971, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19258, 70),
      ))
    }

@delegate:ResourceContentHash(-46_045_216)
public val Res.string.applicant_deleted: StringResource by lazy {
      StringResource("string:applicant_deleted", "applicant_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 23918, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33074, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19329, 49),
      ))
    }

@delegate:ResourceContentHash(-1_033_956_588)
public val Res.string.applicant_hire: StringResource by lazy {
      StringResource("string:applicant_hire", "applicant_hire", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24021, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33221, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19432, 42),
      ))
    }

@delegate:ResourceContentHash(953_344_880)
public val Res.string.applicant_manager_note: StringResource by lazy {
      StringResource("string:applicant_manager_note", "applicant_manager_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24196, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33456, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19591, 42),
      ))
    }

@delegate:ResourceContentHash(244_262_617)
public val Res.string.applicant_manager_note_hint: StringResource by lazy {
      StringResource("string:applicant_manager_note_hint", "applicant_manager_note_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24072, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33296, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19475, 115),
      ))
    }

@delegate:ResourceContentHash(272_810_627)
public val Res.string.applicant_mark_unread: StringResource by lazy {
      StringResource("string:applicant_mark_unread", "applicant_mark_unread", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24247, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33519, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19634, 49),
      ))
    }

@delegate:ResourceContentHash(-1_963_228_151)
public val Res.string.applicant_marked_unread: StringResource by lazy {
      StringResource("string:applicant_marked_unread", "applicant_marked_unread", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24313, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33613, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19684, 55),
      ))
    }

@delegate:ResourceContentHash(174_232_103)
public val Res.string.applicant_note: StringResource by lazy {
      StringResource("string:applicant_note", "applicant_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24385, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33709, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19740, 46),
      ))
    }

@delegate:ResourceContentHash(1_891_771_094)
public val Res.string.applicant_reject: StringResource by lazy {
      StringResource("string:applicant_reject", "applicant_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25275, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34999, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20538, 32),
      ))
    }

@delegate:ResourceContentHash(720_792_632)
public val Res.string.applicant_reject_already_sent: StringResource by lazy {
      StringResource("string:applicant_reject_already_sent", "applicant_reject_already_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24424, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33768, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19787, 89),
      ))
    }

@delegate:ResourceContentHash(-1_890_268_390)
public val Res.string.applicant_reject_no_email: StringResource by lazy {
      StringResource("string:applicant_reject_no_email", "applicant_reject_no_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24514, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 33882, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19877, 101),
      ))
    }

@delegate:ResourceContentHash(1_309_715_039)
public val Res.string.applicant_reject_send_mail: StringResource by lazy {
      StringResource("string:applicant_reject_send_mail", "applicant_reject_send_mail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24620, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34064, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19979, 78),
      ))
    }

@delegate:ResourceContentHash(664_352_520)
public val Res.string.applicant_reject_text: StringResource by lazy {
      StringResource("string:applicant_reject_text", "applicant_reject_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24707, 233),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34195, 341),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20058, 197),
      ))
    }

@delegate:ResourceContentHash(2_025_417_190)
public val Res.string.applicant_reject_title: StringResource by lazy {
      StringResource("string:applicant_reject_title", "applicant_reject_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 24941, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34537, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20256, 46),
      ))
    }

@delegate:ResourceContentHash(492_941_413)
public val Res.string.applicant_rejected: StringResource by lazy {
      StringResource("string:applicant_rejected", "applicant_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25220, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34928, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20487, 50),
      ))
    }

@delegate:ResourceContentHash(485_386_284)
public val Res.string.applicant_rejected_mail: StringResource by lazy {
      StringResource("string:applicant_rejected_mail", "applicant_rejected_mail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25012, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34620, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20303, 75),
      ))
    }

@delegate:ResourceContentHash(1_427_935_924)
public val Res.string.applicant_rejected_no_email: StringResource by lazy {
      StringResource("string:applicant_rejected_no_email", "applicant_rejected_no_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25096, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 34732, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20379, 107),
      ))
    }

@delegate:ResourceContentHash(1_151_104_508)
public val Res.string.applicant_saved: StringResource by lazy {
      StringResource("string:applicant_saved", "applicant_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25312, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35048, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20571, 47),
      ))
    }

@delegate:ResourceContentHash(-1_156_485_563)
public val Res.string.applicant_sent: StringResource by lazy {
      StringResource("string:applicant_sent", "applicant_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25356, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35132, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20619, 38),
      ))
    }

@delegate:ResourceContentHash(8_469_048)
public val Res.string.applicant_stage: StringResource by lazy {
      StringResource("string:applicant_stage", "applicant_stage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25399, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35187, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20658, 31),
      ))
    }

@delegate:ResourceContentHash(-760_170_509)
public val Res.string.applicant_star: StringResource by lazy {
      StringResource("string:applicant_star", "applicant_star", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25431, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35223, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20690, 46),
      ))
    }

@delegate:ResourceContentHash(1_305_037_691)
public val Res.string.applicant_status_contacted: StringResource by lazy {
      StringResource("string:applicant_status_contacted", "applicant_status_contacted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25482, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35290, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20737, 46),
      ))
    }

@delegate:ResourceContentHash(-2_106_507_906)
public val Res.string.applicant_status_hired: StringResource by lazy {
      StringResource("string:applicant_status_hired", "applicant_status_hired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25533, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35349, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20784, 38),
      ))
    }

@delegate:ResourceContentHash(-1_939_820_506)
public val Res.string.applicant_status_new: StringResource by lazy {
      StringResource("string:applicant_status_new", "applicant_status_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25576, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35404, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20823, 32),
      ))
    }

@delegate:ResourceContentHash(1_606_433_069)
public val Res.string.applicant_status_rejected: StringResource by lazy {
      StringResource("string:applicant_status_rejected", "applicant_status_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25613, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35445, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20856, 45),
      ))
    }

@delegate:ResourceContentHash(-170_981_849)
public val Res.string.applicant_status_trial: StringResource by lazy {
      StringResource("string:applicant_status_trial", "applicant_status_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25659, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35503, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20902, 46),
      ))
    }

@delegate:ResourceContentHash(-1_751_332_278)
public val Res.string.applicant_unstar: StringResource by lazy {
      StringResource("string:applicant_unstar", "applicant_unstar", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25710, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35566, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20949, 56),
      ))
    }

@delegate:ResourceContentHash(1_827_956_009)
public val Res.string.applicant_write: StringResource by lazy {
      StringResource("string:applicant_write", "applicant_write", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25759, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35639, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21006, 43),
      ))
    }

@delegate:ResourceContentHash(753_691_171)
public val Res.string.applicants_empty: StringResource by lazy {
      StringResource("string:applicants_empty", "applicants_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25803, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35699, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21050, 56),
      ))
    }

@delegate:ResourceContentHash(224_857_314)
public val Res.string.applicants_filter_all: StringResource by lazy {
      StringResource("string:applicants_filter_all", "applicants_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25868, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35784, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21107, 33),
      ))
    }

@delegate:ResourceContentHash(1_606_433_069)
public val Res.string.applicants_filter_rejected: StringResource by lazy {
      StringResource("string:applicants_filter_rejected", "applicants_filter_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25910, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35822, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21141, 46),
      ))
    }

@delegate:ResourceContentHash(-2_011_135_483)
public val Res.string.applicants_filter_starred: StringResource by lazy {
      StringResource("string:applicants_filter_starred", "applicants_filter_starred", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 25957, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35881, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21188, 49),
      ))
    }

@delegate:ResourceContentHash(-1_278_347_250)
public val Res.string.applicants_filter_unread: StringResource by lazy {
      StringResource("string:applicants_filter_unread", "applicants_filter_unread", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26003, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35931, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21238, 40),
      ))
    }

@delegate:ResourceContentHash(205_840_596)
public val Res.string.applicants_retention: StringResource by lazy {
      StringResource("string:applicants_retention", "applicants_retention", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26056, 224),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 35996, 368),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21279, 200),
      ))
    }

@delegate:ResourceContentHash(1_180_156_533)
public val Res.string.applicants_title: StringResource by lazy {
      StringResource("string:applicants_title", "applicants_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26281, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36365, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21480, 48),
      ))
    }

@delegate:ResourceContentHash(750_434_664)
public val Res.string.apply: StringResource by lazy {
      StringResource("string:apply", "apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26326, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36422, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21529, 21),
      ))
    }

@delegate:ResourceContentHash(-1_448_697_777)
public val Res.string.at_work_break_since: StringResource by lazy {
      StringResource("string:at_work_break_since", "at_work_break_since", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26352, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36468, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21551, 51),
      ))
    }

@delegate:ResourceContentHash(-1_451_180_749)
public val Res.string.at_work_breaks_total: StringResource by lazy {
      StringResource("string:at_work_breaks_total", "at_work_breaks_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26400, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36528, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21603, 52),
      ))
    }

@delegate:ResourceContentHash(-1_223_606_072)
public val Res.string.at_work_checklists: StringResource by lazy {
      StringResource("string:at_work_checklists", "at_work_checklists", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26457, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36609, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21656, 54),
      ))
    }

@delegate:ResourceContentHash(-801_464_994)
public val Res.string.at_work_clock_in: StringResource by lazy {
      StringResource("string:at_work_clock_in", "at_work_clock_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26512, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36672, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21711, 36),
      ))
    }

@delegate:ResourceContentHash(2_130_280_978)
public val Res.string.at_work_clock_out: StringResource by lazy {
      StringResource("string:at_work_clock_out", "at_work_clock_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26557, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36721, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21748, 37),
      ))
    }

@delegate:ResourceContentHash(-817_831_930)
public val Res.string.at_work_instead_of: StringResource by lazy {
      StringResource("string:at_work_instead_of", "at_work_instead_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26603, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36767, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21786, 46),
      ))
    }

@delegate:ResourceContentHash(1_017_804_282)
public val Res.string.at_work_location_outside: StringResource by lazy {
      StringResource("string:at_work_location_outside", "at_work_location_outside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26650, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36822, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21833, 68),
      ))
    }

@delegate:ResourceContentHash(281_927_040)
public val Res.string.at_work_location_unverified: StringResource by lazy {
      StringResource("string:at_work_location_unverified", "at_work_location_unverified", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26715, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 36895, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21902, 63),
      ))
    }

@delegate:ResourceContentHash(-1_387_575_000)
public val Res.string.at_work_nobody_today: StringResource by lazy {
      StringResource("string:at_work_nobody_today", "at_work_nobody_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26791, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37011, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21966, 64),
      ))
    }

@delegate:ResourceContentHash(-1_281_119_727)
public val Res.string.at_work_show_all: StringResource by lazy {
      StringResource("string:at_work_show_all", "at_work_show_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26856, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37120, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22031, 44),
      ))
    }

@delegate:ResourceContentHash(-1_807_179_816)
public val Res.string.at_work_show_less: StringResource by lazy {
      StringResource("string:at_work_show_less", "at_work_show_less", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26913, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37189, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22076, 37),
      ))
    }

@delegate:ResourceContentHash(1_103_725_361)
public val Res.string.at_work_status_done: StringResource by lazy {
      StringResource("string:at_work_status_done", "at_work_status_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26955, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37251, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22114, 35),
      ))
    }

@delegate:ResourceContentHash(2_070_059_717)
public val Res.string.at_work_status_late: StringResource by lazy {
      StringResource("string:at_work_status_late", "at_work_status_late", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 26999, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37303, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22150, 35),
      ))
    }

@delegate:ResourceContentHash(1_649_024_785)
public val Res.string.at_work_status_not_started: StringResource by lazy {
      StringResource("string:at_work_status_not_started", "at_work_status_not_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27043, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37359, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22186, 54),
      ))
    }

@delegate:ResourceContentHash(1_607_887_986)
public val Res.string.at_work_status_on_break: StringResource by lazy {
      StringResource("string:at_work_status_on_break", "at_work_status_on_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27098, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37426, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22241, 47),
      ))
    }

@delegate:ResourceContentHash(-1_198_939_876)
public val Res.string.at_work_status_working: StringResource by lazy {
      StringResource("string:at_work_status_working", "at_work_status_working", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27146, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37486, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22289, 42),
      ))
    }

@delegate:ResourceContentHash(-915_580_753)
public val Res.string.at_work_title: StringResource by lazy {
      StringResource("string:at_work_title", "at_work_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27189, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37533, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22332, 41),
      ))
    }

@delegate:ResourceContentHash(-1_371_239_595)
public val Res.string.at_work_to_review: StringResource by lazy {
      StringResource("string:at_work_to_review", "at_work_to_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27231, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37603, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22374, 37),
      ))
    }

@delegate:ResourceContentHash(1_461_356_616)
public val Res.string.auth_benefit_costs: StringResource by lazy {
      StringResource("string:auth_benefit_costs", "auth_benefit_costs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27277, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37661, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22412, 126),
      ))
    }

@delegate:ResourceContentHash(-6_833_567)
public val Res.string.auth_benefit_requests: StringResource by lazy {
      StringResource("string:auth_benefit_requests", "auth_benefit_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27388, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 37860, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22539, 105),
      ))
    }

@delegate:ResourceContentHash(581_070_732)
public val Res.string.auth_benefit_roster: StringResource by lazy {
      StringResource("string:auth_benefit_roster", "auth_benefit_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27510, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38042, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22645, 115),
      ))
    }

@delegate:ResourceContentHash(480_830_494)
public val Res.string.auth_brand_promise: StringResource by lazy {
      StringResource("string:auth_brand_promise", "auth_brand_promise", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27642, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38246, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22761, 66),
      ))
    }

@delegate:ResourceContentHash(1_443_623_093)
public val Res.string.auth_continue_with_google: StringResource by lazy {
      StringResource("string:auth_continue_with_google", "auth_continue_with_google", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27709, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38341, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22828, 61),
      ))
    }

@delegate:ResourceContentHash(-2_106_478_847)
public val Res.string.auth_email: StringResource by lazy {
      StringResource("string:auth_email", "auth_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27911, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38643, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23010, 38),
      ))
    }

@delegate:ResourceContentHash(775_842_731)
public val Res.string.auth_email_not_verified: StringResource by lazy {
      StringResource("string:auth_email_not_verified", "auth_email_not_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27775, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38415, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22890, 119),
      ))
    }

@delegate:ResourceContentHash(-1_231_453_544)
public val Res.string.auth_fill_all_fields: StringResource by lazy {
      StringResource("string:auth_fill_all_fields", "auth_fill_all_fields", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 27946, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38706, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23049, 56),
      ))
    }

@delegate:ResourceContentHash(571_038_407)
public val Res.string.auth_forgot_password: StringResource by lazy {
      StringResource("string:auth_forgot_password", "auth_forgot_password", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28011, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38779, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23106, 52),
      ))
    }

@delegate:ResourceContentHash(1_429_083_766)
public val Res.string.auth_full_name: StringResource by lazy {
      StringResource("string:auth_full_name", "auth_full_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28072, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38860, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23159, 34),
      ))
    }

@delegate:ResourceContentHash(-1_862_677_136)
public val Res.string.auth_i_have_verified: StringResource by lazy {
      StringResource("string:auth_i_have_verified", "auth_i_have_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28119, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 38927, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23194, 60),
      ))
    }

@delegate:ResourceContentHash(423_012_661)
public val Res.string.auth_login_title: StringResource by lazy {
      StringResource("string:auth_login_title", "auth_login_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28188, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39016, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23255, 44),
      ))
    }

@delegate:ResourceContentHash(5_881_907)
public val Res.string.auth_new_to_evoshift: StringResource by lazy {
      StringResource("string:auth_new_to_evoshift", "auth_new_to_evoshift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28241, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39073, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23300, 52),
      ))
    }

@delegate:ResourceContentHash(-317_133_092)
public val Res.string.auth_or: StringResource by lazy {
      StringResource("string:auth_or", "auth_or", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28302, 19),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39138, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23353, 19),
      ))
    }

@delegate:ResourceContentHash(582_314_914)
public val Res.string.auth_password: StringResource by lazy {
      StringResource("string:auth_password", "auth_password", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28322, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39162, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23373, 33),
      ))
    }

@delegate:ResourceContentHash(-1_405_492_154)
public val Res.string.auth_register_title: StringResource by lazy {
      StringResource("string:auth_register_title", "auth_register_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28352, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39200, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23407, 47),
      ))
    }

@delegate:ResourceContentHash(-2_037_157_486)
public val Res.string.auth_resend_verification: StringResource by lazy {
      StringResource("string:auth_resend_verification", "auth_resend_verification", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28400, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39292, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23455, 68),
      ))
    }

@delegate:ResourceContentHash(-578_929_451)
public val Res.string.auth_reset_button: StringResource by lazy {
      StringResource("string:auth_reset_button", "auth_reset_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 28461, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 39425, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23524, 33),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("answers_group_no_answer", Res.string.answers_group_no_answer)
  map.put("answers_group_unavailable", Res.string.answers_group_unavailable)
  map.put("answers_hide_people", Res.string.answers_hide_people)
  map.put("answers_no_answer", Res.string.answers_no_answer)
  map.put("answers_show_people", Res.string.answers_show_people)
  map.put("answers_slot_only_other", Res.string.answers_slot_only_other)
  map.put("answers_title", Res.string.answers_title)
  map.put("answers_whole_day", Res.string.answers_whole_day)
  map.put("app_name", Res.string.app_name)
  map.put("appearance_accent", Res.string.appearance_accent)
  map.put("appearance_accent_bronze", Res.string.appearance_accent_bronze)
  map.put("appearance_accent_gold", Res.string.appearance_accent_gold)
  map.put("appearance_accent_silver", Res.string.appearance_accent_silver)
  map.put("appearance_apply", Res.string.appearance_apply)
  map.put("appearance_base", Res.string.appearance_base)
  map.put("appearance_base_bottle_green", Res.string.appearance_base_bottle_green)
  map.put("appearance_base_burgundy", Res.string.appearance_base_burgundy)
  map.put("appearance_base_navy", Res.string.appearance_base_navy)
  map.put("appearance_current", Res.string.appearance_current)
  map.put("appearance_hint", Res.string.appearance_hint)
  map.put("appearance_preview", Res.string.appearance_preview)
  map.put("appearance_title", Res.string.appearance_title)
  map.put("applicant_availability", Res.string.applicant_availability)
  map.put("applicant_call", Res.string.applicant_call)
  map.put("applicant_consent_future", Res.string.applicant_consent_future)
  map.put("applicant_cv", Res.string.applicant_cv)
  map.put("applicant_delete", Res.string.applicant_delete)
  map.put("applicant_delete_confirm_text", Res.string.applicant_delete_confirm_text)
  map.put("applicant_delete_confirm_title", Res.string.applicant_delete_confirm_title)
  map.put("applicant_deleted", Res.string.applicant_deleted)
  map.put("applicant_hire", Res.string.applicant_hire)
  map.put("applicant_manager_note", Res.string.applicant_manager_note)
  map.put("applicant_manager_note_hint", Res.string.applicant_manager_note_hint)
  map.put("applicant_mark_unread", Res.string.applicant_mark_unread)
  map.put("applicant_marked_unread", Res.string.applicant_marked_unread)
  map.put("applicant_note", Res.string.applicant_note)
  map.put("applicant_reject", Res.string.applicant_reject)
  map.put("applicant_reject_already_sent", Res.string.applicant_reject_already_sent)
  map.put("applicant_reject_no_email", Res.string.applicant_reject_no_email)
  map.put("applicant_reject_send_mail", Res.string.applicant_reject_send_mail)
  map.put("applicant_reject_text", Res.string.applicant_reject_text)
  map.put("applicant_reject_title", Res.string.applicant_reject_title)
  map.put("applicant_rejected", Res.string.applicant_rejected)
  map.put("applicant_rejected_mail", Res.string.applicant_rejected_mail)
  map.put("applicant_rejected_no_email", Res.string.applicant_rejected_no_email)
  map.put("applicant_saved", Res.string.applicant_saved)
  map.put("applicant_sent", Res.string.applicant_sent)
  map.put("applicant_stage", Res.string.applicant_stage)
  map.put("applicant_star", Res.string.applicant_star)
  map.put("applicant_status_contacted", Res.string.applicant_status_contacted)
  map.put("applicant_status_hired", Res.string.applicant_status_hired)
  map.put("applicant_status_new", Res.string.applicant_status_new)
  map.put("applicant_status_rejected", Res.string.applicant_status_rejected)
  map.put("applicant_status_trial", Res.string.applicant_status_trial)
  map.put("applicant_unstar", Res.string.applicant_unstar)
  map.put("applicant_write", Res.string.applicant_write)
  map.put("applicants_empty", Res.string.applicants_empty)
  map.put("applicants_filter_all", Res.string.applicants_filter_all)
  map.put("applicants_filter_rejected", Res.string.applicants_filter_rejected)
  map.put("applicants_filter_starred", Res.string.applicants_filter_starred)
  map.put("applicants_filter_unread", Res.string.applicants_filter_unread)
  map.put("applicants_retention", Res.string.applicants_retention)
  map.put("applicants_title", Res.string.applicants_title)
  map.put("apply", Res.string.apply)
  map.put("at_work_break_since", Res.string.at_work_break_since)
  map.put("at_work_breaks_total", Res.string.at_work_breaks_total)
  map.put("at_work_checklists", Res.string.at_work_checklists)
  map.put("at_work_clock_in", Res.string.at_work_clock_in)
  map.put("at_work_clock_out", Res.string.at_work_clock_out)
  map.put("at_work_instead_of", Res.string.at_work_instead_of)
  map.put("at_work_location_outside", Res.string.at_work_location_outside)
  map.put("at_work_location_unverified", Res.string.at_work_location_unverified)
  map.put("at_work_nobody_today", Res.string.at_work_nobody_today)
  map.put("at_work_show_all", Res.string.at_work_show_all)
  map.put("at_work_show_less", Res.string.at_work_show_less)
  map.put("at_work_status_done", Res.string.at_work_status_done)
  map.put("at_work_status_late", Res.string.at_work_status_late)
  map.put("at_work_status_not_started", Res.string.at_work_status_not_started)
  map.put("at_work_status_on_break", Res.string.at_work_status_on_break)
  map.put("at_work_status_working", Res.string.at_work_status_working)
  map.put("at_work_title", Res.string.at_work_title)
  map.put("at_work_to_review", Res.string.at_work_to_review)
  map.put("auth_benefit_costs", Res.string.auth_benefit_costs)
  map.put("auth_benefit_requests", Res.string.auth_benefit_requests)
  map.put("auth_benefit_roster", Res.string.auth_benefit_roster)
  map.put("auth_brand_promise", Res.string.auth_brand_promise)
  map.put("auth_continue_with_google", Res.string.auth_continue_with_google)
  map.put("auth_email", Res.string.auth_email)
  map.put("auth_email_not_verified", Res.string.auth_email_not_verified)
  map.put("auth_fill_all_fields", Res.string.auth_fill_all_fields)
  map.put("auth_forgot_password", Res.string.auth_forgot_password)
  map.put("auth_full_name", Res.string.auth_full_name)
  map.put("auth_i_have_verified", Res.string.auth_i_have_verified)
  map.put("auth_login_title", Res.string.auth_login_title)
  map.put("auth_new_to_evoshift", Res.string.auth_new_to_evoshift)
  map.put("auth_or", Res.string.auth_or)
  map.put("auth_password", Res.string.auth_password)
  map.put("auth_register_title", Res.string.auth_register_title)
  map.put("auth_resend_verification", Res.string.auth_resend_verification)
  map.put("auth_reset_button", Res.string.auth_reset_button)
}
